(function() {
	'use strict';

	angular
		.module('iqxCore')
    .controller('JobSearchJobCtrl', JobSearchJobCtrl)

  function JobSearchJobCtrl($scope, FormSvc, ApiSvc, ApplicationSvc, $routeParams, $location, $http, $window, loginSvc, JobSearchSvc, $sce) {

    $scope.notes = ''

    if ($scope.userHasRight('CANDHIDEJOBSPAGE')) {
      $location.url('/noPermission')
      return
    }
  
    $scope.register = function () {
      $window.open('/xregister/?fromjobsearch=true', 'registerWindow')
    }
    
    $scope.login=function (username,password) {
      $scope.isLoading=true
      $scope.loginerr=''
      if (!username) {
        $scope.isLoading=false
        return ($scope.loginerr='Missing user name')
      }
      if (!password) {
        $scope.isLoading=false
        return ($scope.loginerr='Missing password')
      }
  
      $http.post('/api/auth/login', {username:username, password:password})
      .then(function (res) {
        ApiSvc.CheckIQXResult(res.data)
        loginSvc.setLoggedIn(res.data)
        .then(function(){
          var p=ApplicationSvc.postLoginRoute  // Navigate to wherever was last requested in the un-loggedin state (default=/)
          ApplicationSvc.postLoginRoute='/'    // Reset the default
          $location.path(p)
        })
      })
      .catch(function (err) {
        if (angular.isObject(err) && err.status && err.status==401) {
          $scope.loginerr='Invalid user name or password'
        } else {
          $scope.loginerr=ApiSvc.ExtractError(err)
        }
        $scope.isLoading=false
      })
    }
  
    $scope.goToLogin=function(){
      $scope.registerOnLoginBox=true
      return FormSvc.modalInfo($scope,'loginBox',{choices:[{desc:"Close",type:"primary",code:''}]},'lg')
    }
    
    $scope.goBack=function(){
      $window.history.back()
    }
  
    $scope.resetPassword=function(){
      $window.open('/resetpassword')
    }
  
    // If ISO date formats as UK
    $scope.jFmt=function(val){
      // if typeof html then trust it
      if (typeof val === 'string' && val.indexOf('<') > -1) {
        val = $sce.trustAsHtml(val)
      }
      if (val==undefined || typeof val==='number'){
        return val
      }
      var ln=val.length
      if (ln==10) {
        var ar=val.match(/^(\d{4}).(\d{2}).(\d{2})/)
        if (ar){  // iso date - format as dd/mm/yyyy
          return ar[3]+'/'+ar[2]+'/'+ar[1]
        }
      }
      return val
    }
      
    $scope.emailJob = function() {
      var mailto = $scope.job.contactemail
      var subject = "Enquiry About " + $scope.job.position + " (ref " + $scope.job.refcode + ")"
      var yourMessage = "Your Enquiry"
      document.location.href = "mailto:" + mailto + "?subject=" +
      encodeURIComponent(subject) +
      "&body=" + encodeURIComponent(yourMessage)
    }
  
    $scope.applyRole = function() {
      var pVacancyId = $scope.job.vacancyid
      var saveData = {
        pRefCode: pVacancyId,
        pPersonID: ApplicationSvc.currentUser.personID || ''
      }
      $scope.applied=undefined
      FormSvc.modalForm($scope,'jobApplyNotes',{},'md',{label:'col-sm-3', data:'col-sm-7'})
      .then(function(res){
        if(res.notes){
          saveData.pNotes=res.notes
        }
        return  ApiSvc.fetch($scope,{fetchAPI:'call/NetCandidateAddToShortlist?'+JobSearchSvc.serialize(saveData), multiRow:false, fetchTarget:"applied"})
      })
       
      .then(function() {
        if ($scope.applied) {
          $scope.job.shortListed=true
          FormSvc.alert("Success", "Your job application has been received.", "success")
        } else {
          FormSvc.alert("Error", "There was an error processing the job application.", "error")
        }
      })
      .catch(function(err){
        if(!err){
          return true
        }
        if(err.iqxError && (err.iqxError.errorNumber==135)){  // Already applied
          $scope.job.shortListed=true
        }
      })
    }
    
    $scope.findSimilarJobs=function(){
      var s=''
      function addS(s1){
        if(s1){
          s=s+' '+s1
        }
      }
      addS($scope.job.position)
      addS($scope.job.addressLocality)
      angular.forEach($scope.rawFields,function(f){
        if(f.type=='select' || f.type=='multiselect'){ // Includes department and questions
          addS($scope.job[f.name])
        }
      })
      JobSearchSvc.searchInit()  // Force a new search 
      JobSearchSvc.searchValues={$text:s.trim()}
      $location.url('/jobsearch/results')  // Go to the job search results page
    }
  
    $scope.fetchJob = function() {   // single job
      return JobSearchSvc.getSearchFields()
      .then(function(){return JobSearchSvc.findJob($routeParams.viewjob)})
      .then(function(){
        if (!JobSearchSvc.rawJob) {
          FormSvc.alert("Error", "Job not found", "error")
          return
          }  
        $scope.job=JobSearchSvc.rawJob
        $scope.rawFields=JobSearchSvc.rawFields
        })
      }
   
    $scope.fetchJob()  // single job
    .then(function(){
      if ($routeParams.authenticated === 'true') {
        $scope.applyRole()
      }
    })    
  }
    
})()

